const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/app/cycle/$cycleId/survey/$fortySurveyType/$surveyId')({
  validateSearch: search => {
    return {
      // 동료 피드백
      reviewerName: search.reviewerName as string | undefined,
      revieweeName: search.revieweeName as string | undefined,
      // 웨이마크
      name: search.name as string | undefined
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}